exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#toasts{\n  min-width: 8%;\n  right: 15px;\n  bottom: 1%;\n  position: absolute;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/toast-notification/toast-notification.component.css
// module id = ../../../../../src/app/_components/toast-notification/toast-notification.component.css
// module chunks = main